const CheckAttr = (attr: any): boolean => {
    if (attr === undefined || attr === null || attr === false || String(attr).length === 0) {
        return false;
    }

    return true;
};

export default CheckAttr;
